import qs from "qs";

// Action Types
export const LIST = "bontempo/newsCategories/LIST";
export const LIST_SUCCESS = "bontempo/newsCategories/LIST_SUCCESS";
export const LIST_FAIL = "bontempo/newsCategories/LIST_FAIL";

export const DETAILS = "bontempo/newsCategories/DETAILS";
export const DETAILS_SUCCESS = "bontempo/newsCategories/DETAILS_SUCCESS";
export const DETAILS_FAIL = "bontempo/newsCategories/DETAILS_FAIL";

export const SAVE = "bontempo/newsCategories/SAVE";
export const SAVE_SUCCESS = "bontempo/newsCategories/SAVE_SUCCESS";
export const SAVE_FAIL = "bontempo/newsCategories/SAVE_FAIL";

export const DELETE = "bontempo/newsCategories/DELETE";
export const DELETE_SUCCESS = "bontempo/newsCategories/DELETE_SUCCESS";
export const DELETE_FAIL = "bontempo/newsCategories/DELETE_FAIL";

// Reducer
const initialState = {
  data: null,
  details: null,
  loading: false,
  module: "noticias/categorias",
  total: 0
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LIST:
      return { ...state, loading: true };
    case LIST_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    case LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: "Não foi possível completar a requisição."
      };

    case DETAILS:
      return { ...state, loading: true };
    case DETAILS_SUCCESS:
      return {
        ...state,
        details: action.payload.data,
        loading: false
      };
    case DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: "Não foi possível completar a requisição."
      };

    case SAVE:
      return { ...state, loading: true };
    case SAVE_SUCCESS:
    case SAVE_FAIL:
      return { ...state, loading: false };

    case DELETE:
      return { ...state, loading: true };
    case DELETE_SUCCESS:
    case DELETE_FAIL:
      return { ...state, loading: false };

    default:
      return state;
  }
}

// Action Creators
export function get(params) {
  return {
    type: LIST,
    payload: {
      request: {
        url: `/news/categories?${qs.stringify(params)}`
      }
    }
  };
}

export function getDetails(id) {
  return {
    type: DETAILS,
    payload: {
      request: {
        url: `/news/categories/${id}`
      }
    }
  };
}

export function add(data) {
  return {
    type: SAVE,
    payload: {
      request: {
        url: `/news/categories`,
        method: "post",
        data: data
      }
    }
  };
}

export function edit(data, id) {
  return {
    type: SAVE,
    payload: {
      request: {
        url: `/news/categories/${id}`,
        method: "put",
        data: data
      }
    }
  };
}

export function remove(id) {
  return {
    type: DELETE,
    payload: {
      request: {
        url: `/news/categories/${id}`,
        method: "delete"
      }
    }
  };
}
